import React, { useState, useEffect, useRef } from "react";
import "./books.css";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { Modal, Input, Spin, Tooltip } from "antd";
import { message } from "../../components/antdMessageBridge";
import BookShelf from "../../images/book.svg";
import SliderUI from "../manifest/manifest-slide";
import BookCoverDummy from "../../assets/img/cover.png";
import { Html5QrcodeScanType } from "html5-qrcode";
import { useAuth } from "../../auth/AuthContext";
import ConfirmationModalStopImg from "../../assets/img/svg/xstopalert.svg";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import ConfirmationModal from "../../components/confirmationmodal/confirmation-modal";
import regexService from "../../components/commonregex/regexService";
import validationService from "../../components/commonvalidation/validationService";
import { showManualEntryDisabledWarning } from "../../components/commonvalidation/manualEntryWarning";
import IntakeSlide from "./Intake-reject-slide";
import useFieldPermissions from "../../hooks/useFieldPermissions";


const MyForm = () => {
    const initialIntakeForm = {
        bid: "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        weight: 0.75,
        isbn: "",
        condition: "",
        bookType: "",
        usedCondition: "Acceptable",
        content: "",
        bookFormat: "",
        eqComplexityLevel: "",
        comments: "",
        reasonForException: "",
        rackAndShelf: "",
        rackShelf: "",
        rackAndShelfpopUp: "",
        bidFromPopup:"",
        version: "",
        vendor: "",
    }
    const [form, setForm] = useState(initialIntakeForm);
    const [masterData, setMasterData] = useState({
        bookFormat: [],
        condition: [],
        eqComplexityLevelFormula: [],
        bookFormatExceptions: [],
        language: [],
    });
    const [languageData, setLanguageData] = useState({});
    const [vendorData, setVendorData] = useState([]);
    const { accessToken, isAuthenticated } = useAuthToken();
    const [visible, setVisible] = useState(false);
    const [isbnInput, setIsbnInput] = useState('');
    const [isDuplicateIsbn, setIsDuplicateIsbn] = useState(false);
    const lastKeyTimeRef = useRef(0);
    const clearTimerRef = useRef(null);
    const lastBidKeyTimeRef = useRef(0);
    const clearBidTimerRef = useRef(null);
    const lastBidFromPopupKeyTimeRef = useRef(0);
    const clearBidFromPopupTimerRef = useRef(null);

    const { roleUserId } = useAuth();
    const { isReadOnly } = useFieldPermissions("intake");

    const [commentsvisible, setCommentsVisible] = useState(false);
    const [bookCover, setBookCover] = useState("");
    const [commentsList, setCommentsList] = useState([]);
    const [currentBidForComments, setCurrentBidForComments] = useState("");
    const [hasUserInteracted, setHasUserInteracted] = useState(false);
    const [errors, setErrors] = useState({});
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);
    const [bsnVisible, setBsnVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [rackShelfpopUp, setRackShelfpopUp] = useState("");
    const [regexLoaded, setRegexLoaded] = useState(false);
    const [langErrorMsg, setLangErrorMsg] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [rejectSubmissionData, setRejectSubmissionData] = useState(null);

    const [selectedLanguage, setSelectedLanguage] = useState("");
    const initialBSNForm = {
        bid: "",
        isbn: "",
        version: "",
        rackAndShelf: 0,
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        pageCount: 0,
        language: "",
        weight: 0,
        format: "",
        condition: "",
        usedCondition: "",
        content: "",
        eqComplexityLevel: "",
        createdBy: 0,
        formatException: 0,
        rackShelf: "",
        bookCoverImageURL: "",
        bookType: "",
        updatedPageCount: 0,
        isAuthorizedISBN: ""
    }
    const [bsnVisibleForm, setBsnVisibleForm] = useState(initialBSNForm);

    const UserDetails = JSON.parse(localStorage.getItem("user"));
    const LogoText = UserDetails?.name?.toUpperCase() || "U";
    useEffect(() => {
        if (form?.rackAndShelfpopUp?.trim() !== "") {
            setErrors(prev => ({ ...prev, rackShelfpopUp: "" }))
        }
        if (form?.bidFromPopup?.trim() !== "") {
            setErrors(prev => ({ ...prev, bidFromPopup: "" }))
        }
    }, [form.rackAndShelfpopUp, form.bidFromPopup]);
    useEffect(() => {
        return () => {
            Modal.destroyAll();
        };
    }, []);

    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                await validationService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);
    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetMasterData, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });


                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setMasterData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };

        fetchMasterData();
    }, []);
    useEffect(() => {
        const fetchLanguageData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetLanguageListwithCode, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });


                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setLanguageData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };

        fetchLanguageData();
    }, []);
    const populateFieldsByIsbn = async (isbn) => {
        // Fetch logic similar to scanning case, updating form with fetched data
        setForm(prev => ({
            ...prev,
            isbn: isbn,
            // other fields from API response
        }));
        UserLogin(isbn)
    };
    const [isbnSubmitButton, setIsbnSubmitButton] = useState(false);
    const handleIsbnBlur = () => {
        setIsbnSubmitButton(true);
        setTimeout(() => setIsbnSubmitButton(false), 3000);
        if (isbnInput.trim() !== '') {
            const isbnResult = validationService.validateISBN(isbnInput);
            if (!isbnResult.isValid) {
                message.error({ content: isbnResult.error, key: "isbn-validation-error" });
                clearForm();
                return;
            }
            populateFieldsByIsbn(isbnInput.trim());
        }
    };


    useEffect(() => {
        if (activeScanner === 'ISBN' && decodedResults.length > 0) {
            const scannedValue = decodedResults[decodedResults.length - 1].decodedText;
            setIsbnInput(scannedValue);
        }
    }, [decodedResults, activeScanner]);

    async function checkExistingBid(bid) {
        const url = CommonObj.Endpoints.GetBookByBIDandStatus;
        let pageName = {
            bid: form.bid,
            createdBy: roleUserId,
        };
        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(pageName),
            });
            if (!response.ok) throw new Error(`Response status: ${response.status}`);
            const result = await response.json();

            if (result && result.length > 0) {
                const bookData = result[0];

                setForm({
                    ...form,
                    bid: bookData.bid || form.bid,
                    title: bookData.title,
                    author: bookData.author,
                    publisher: bookData.publisher,
                    isbN10: bookData.isbN10,
                    isbN13: bookData.isbN13,
                    bookPageCount: bookData.pageCount,
                    language: selectedLanguage,
                    weight: bookData.weight || "0.75",
                    isbn: bookData.isbn || form.isbn,
                    bookFormat: bookData.format || form.bookFormat,
                    condition: bookData.condition || form.condition,
                    usedCondition: bookData.usedCondition || form.usedCondition,
                    eqComplexityLevel:
                        bookData.eqComplexityLevel || form.eqComplexityLevel,
                    content: bookData.content || form.content,
                    rackShelf: bookData.rackShelf || form.rackShelf,
                    rackAndShelf: bookData.rackAndShelf || form.rackAndShelf,
                });
                setBookCover(bookData.bookCoverImageURL);
                setSelectedLanguage(bookData.language);
            }
        } catch (error) {
            console.error(error.message);
        }
    }
    useEffect(() => {
        if (
            !form.bookFormat ||
            form.content.length === 0 ||
            masterData.eqComplexityLevelFormula.length === 0
        ) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
            return;
        }

        const bookFormatObj = masterData.bookFormat.find(
            (bf) => bf.format === form.bookFormat
        );
        if (!bookFormatObj) return;

        const selectedConditionIds = form.content
            .map((contentName) => {
                const conditionObj = masterData.condition.find(
                    (c) => c.fileType === contentName
                );
                return conditionObj ? conditionObj.id.toString() : null;
            })
            .filter((id) => id !== null);

        let bestMatch = null;
        for (const formula of masterData.eqComplexityLevelFormula) {
            if (formula.bookFormat !== bookFormatObj.id.toString()) {
                continue;
            }

            const formulaConditions = formula.condition.split(",");

            if (
                formulaConditions.length === selectedConditionIds.length &&
                formulaConditions.every((condId) =>
                    selectedConditionIds.includes(condId)
                )
            ) {
                bestMatch = formula;
                break;
            }
        }

        if (bestMatch) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: bestMatch.level }));
            setErrors(prev => ({
                ...prev,
                ['eqComplexityLevel']: ""
            }));
        } else {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
        }
    }, [form.bookFormat, form.content, masterData]);
    const handleContentChange = (e) => {
        const { name, value, checked } = e.target;

        setForm((prev) => {
            const currentContent = prev.content;

            if (checked) {
                return { ...prev, content: [...currentContent, value] };
            } else {
                return {
                    ...prev,
                    content: currentContent.filter((item) => item !== value),
                };
            }
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const openCommentsSlider = async (bid) => {
        if (!bid) {
            message.warning("Please enter BID before viewing comments.");
            return;
        }

        setCurrentBidForComments(bid);
        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data || []);
            setCommentsVisible(true);
        } catch (error) {
            message.error(`Failed to fetch comments: ${error.message}`);
        }
    };

    const saveComment = async () => {
        if (!currentBidForComments.trim()) {
            message.warning("No BID selected for saving comments.");
            return;
        }
        if (!form.comments.trim()) {
            message.warning("Please enter a comment before saving.");
            return;
        }
        const payload = {
            bid: currentBidForComments,
            process: 3,
            status: 7,
            comments: form.comments,
            createdBy: roleUserId,
        };
        setLoad(true)
        try {
            const response = await fetch(CommonObj.Endpoints.InsertComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                const result = await response.json();
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            await response.json();
            message.success("Comment saved successfully!");
            setForm((prev) => ({ ...prev, comments: "" }));

            openCommentsSlider(currentBidForComments);
        } catch (error) {
            message.error({ content: error.message, duration: 5 });
        } finally {
            setLoad(false)
        }
    };
    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }

    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);
        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText.trim();
            switch (activeScanner) {
                case "ISBN":
                    setForm((prev) => ({ ...prev, isbn: scannedValue }));
                    if (scannedValue && scannedValue.trim() !== "") {
                        const isbnResult = validationService.validateISBN(scannedValue);
                        if (!isbnResult.isValid) {
                            message.error({ content: isbnResult.error, key: "isbn-validation-error" });
                            clearForm();
                            setActiveScanner(null);
                            setDecodedResults([]);
                            return;
                        }
                    }
                    UserLogin(scannedValue);
                    break;
                case "BID":
                    setForm((prev) => ({ ...prev, bid: scannedValue }));
                    setErrors((prev) => ({ ...prev, bid: "" }));
                    break;
                case "Rack & Shelf ID":
                    setForm((prev) => ({ ...prev, rackAndShelf: scannedValue }));
                    break;
                case "Rack & Shelf Popup":
                    setForm((prev) => ({ ...prev, rackAndShelfpopUp: scannedValue }));
                    break;
                case "BID Popup":
                    setForm((prev) => ({ ...prev, bidFromPopup: scannedValue }));
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);

    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };

    const handleChangpopUp = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));

        if (value && value.trim() !== "") {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };
    const handleLanguageChange = (e) => {
        const { name, value } = e.target;
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
        setSelectedLanguage(e.target.value);
        setForm((prev) => ({
            ...prev, [name]: value,
        }))
    }
    const handleVendorChange = (e) => {
        const { name, value } = e.target;
        const selectedVendorName =
            vendorData.find((vendor) => String(vendor.vendorID) === String(value))?.vendorName ||
            value;

        message.warning(`The vendor ${selectedVendorName} is changed`);

        setForm((prev) => ({ ...prev, [name]: value }));
        if (value && value.trim() !== "") {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => {
            const updatedForm = { ...prev, [name]: value };

            // If ISBN field is cleared, reset all populated data
            if (name === 'isbn' && value.trim() === '') {
                setIsbnInput(''); // Also clear the other ISBN input
                setBookCover('');
                setSelectedLanguage("");
                setErrors({});
                setIsDuplicateIsbn(false);
                setVendorData([]);
                return {
                    bid: '',
                    title: '',
                    author: '',
                    publisher: '',
                    isbN10: '',
                    isbN13: '',
                    bookPageCount: '',
                    language: '',
                    weight: 0.75,
                    isbn: '',
                    condition: '',
                    bookType: '',
                    usedCondition: '',
                    content: [],
                    bookFormat: '',
                    eqComplexityLevel: '',
                    comments: '',
                    reasonForException: '',
                    rackAndShelf: '',
                    rackShelf: '',
                    version: '1.0',
                };
            }

            if (name === "bookFormat" && value === "Exceptions") {
                updatedForm.eqComplexityLevel = "";
            }
            if (name === "condition" && value === "Used Condition") {
                updatedForm.usedCondition = "Acceptable";
            } else if (name === "condition" && value === "New Book") {
                updatedForm.usedCondition = "";
            }
            return updatedForm;
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validate = () => {
        const newErrors = {};

        // BID validation
        const bidError = validationService.validateBid(form.bid);
        if (!form.bid || !form.bid.trim()) {
            newErrors.bid = isReadOnly("bid") 
            ? "Scan the BID number of the book" 
            : "Please Enter / Scan the BID number of the book";
        } else if (bidError) {
            newErrors.bid = bidError;
        }

        // ISBN validations
        const isbnResult = validationService.validateISBN(form.isbn);
        if (!isbnResult.isValid) newErrors.isbn = isbnResult.error;

        const isbn10Result = validationService.validateISBN10(form.isbN10);
        if (!isbn10Result.isValid) newErrors.isbN10 = isbn10Result.error;

        const isbn13Result = validationService.validateISBN13(form.isbN13);
        if (!isbn13Result.isValid) newErrors.isbN13 = isbn13Result.error;

        // Required fields + regex pattern validation
        const titleError = validationService.validateTitle(form.title);
        if (titleError) newErrors.title = titleError === "Title is required" ? "Please Enter Title of the Book" : titleError;

        const authorError = validationService.validateAuthor(form.author);
        if (authorError) newErrors.author = authorError === "Author is required" ? "Please Enter Author of the Book" : authorError;

        const publisherError = validationService.validatePublisher(form.publisher);
        if (publisherError) newErrors.publisher = publisherError === "Publisher is required" ? "Please Enter Publisher of the Book" : publisherError;

        const languageError = validationService.validateLanguage(selectedLanguage);
        if (languageError) newErrors.language = languageError;

        if (!form.vendor || !form.vendor.trim()) {
            newErrors.vendor = "Please select a Vendor";
        }

        const conditionError = validationService.validateCondition(form.condition);
        if (conditionError) newErrors.condition = conditionError;

        const bookTypeError = validationService.validateBookType(form.bookType);
        if (bookTypeError) newErrors.bookType = bookTypeError;

        const bookFormatError = validationService.validateBookFormat(form.bookFormat);
        if (bookFormatError) newErrors.bookFormat = bookFormatError;

        const rackShelfError = validationService.validateRackAndShelf(form.rackAndShelf);
        if (rackShelfError) newErrors.rackAndShelf = rackShelfError;

        // Rack shelf regex validation
        if (!validationService.isMissing(form.rackAndShelf) && regexLoaded) {
            const val = regexService.validateRackShelf(form.rackAndShelf.trim());
            if (!val.isValid) newErrors.rackAndShelf = "Input format invalid: No matching pattern found.";
        }

        // Page count
        const pageCountResult = validationService.validatePageCount(form.bookPageCount);
        if (!pageCountResult.isValid) newErrors.bookPageCount = pageCountResult.error;

        // Content
        const contentError = validationService.validateContent(form.content);
        if (contentError) newErrors.content = contentError;

        // Conditional: Used Condition
        const usedConditionError = validationService.validateUsedCondition(form.usedCondition, form.condition);
        if (usedConditionError) newErrors.usedCondition = usedConditionError;

        // Conditional: EQ-Complexity or Exception
        const isException = form.bookFormat === "Exceptions";
        if (isException && validationService.isMissing(form.reasonForException)) {
            newErrors.reasonForException = "Reason for exception is required when book type is Exceptions";
        } else {
            const eqError = validationService.validateEQComplexityLevel(form.eqComplexityLevel, form.bookFormat);
            if (eqError) newErrors.eqComplexityLevel = eqError;
        }
        const commentError = validationService.validateComments(form.comments);
        if (commentError) {
            message.warning(commentError);
            return;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const isSelectedMissingFromMaster = selectedLanguage && !masterData.language.some(
        (lang) => lang.languageName === selectedLanguage
    );
    const handleClear = () => {

        const hasFormData = Object.keys(form).some(key => {
            const value = form[key];
            const initialValue = initialIntakeForm[key];
            setSelectedLanguage("");
            if (Array.isArray(value)) {
                return value.length > 0;
            }

            if (typeof value === 'string') {
                return value.trim() !== '' && value !== initialValue;
            }

            if (typeof value === 'number') {
                return value !== initialValue;
            }

            return false;
        });

        if (hasFormData){
            ConfirmationModal.showClearConfirmation(
                () => {
                    setIsbnInput('');
                    setForm(initialIntakeForm);
                    setErrors({});
                    setBookCover('');
                    setSelectedLanguage("");
                    setIsDuplicateIsbn(false);
                    setVendorData([]);
                },
            );
        }
    };
    const handleSubmitIsbn = (e) => {
        setForm(prev => ({
            ...prev,
            isbn: isbnInput,
        }));
    };
    const handleIsbnKeyPress = (e) => {
        if (isReadOnly("isbn")) {
            return;
        }

        if (e.key === 'Enter') {
            e.preventDefault();
            if (isbnInput.trim() !== '') {
                const isbnResult = validationService.validateISBN(isbnInput);
                if (!isbnResult.isValid) {
                    message.error({ content: isbnResult.error, key: "isbn-validation-error" });
                    clearForm();
                    return;
                }
                populateFieldsByIsbn(isbnInput);
            }
        }
    };

    const handleIsbnReadOnlyKeyDown = (e) => {
        if (!isReadOnly("isbn")) {
            return;
        }

        // Let native copy/paste behave normally (no custom clipboard handling).
        const isCopyOrPasteShortcut =
            (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
        if (isCopyOrPasteShortcut) {
            return;
        }

        if (e.key === 'Enter' || e.key === 'Tab') {
            return;
        }

        const currentTime = Date.now();
        const timeDiff = currentTime - lastKeyTimeRef.current;
        lastKeyTimeRef.current = currentTime;

        // A physical scanner sends characters within a few milliseconds of each
        // other, so only block keystrokes that arrive slowly (manual typing).
        // The very first keystroke (field currently empty) is always let through
        // so a scan burst never loses its first character.
        const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
        if (!isSlowManualKeystroke) {
            return;
        }

        e.preventDefault();
        setIsbnInput('');

        clearTimeout(clearTimerRef.current);
        clearTimerRef.current = setTimeout(() => {
            showManualEntryDisabledWarning();
        }, 300);
    };

    const handleBidKeyPress = (e) => {
        if (isReadOnly("bid")) {
            return;
        }

        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };

    const handleBidReadOnlyKeyDown = (e) => {
        if (!isReadOnly("bid")) {
            return;
        }

        // Let native copy/paste behave normally (no custom clipboard handling).
        const isCopyOrPasteShortcut =
            (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
        if (isCopyOrPasteShortcut) {
            return;
        }

        if (e.key === 'Enter' || e.key === 'Tab') {
            return;
        }

        const currentTime = Date.now();
        const timeDiff = currentTime - lastBidKeyTimeRef.current;
        lastBidKeyTimeRef.current = currentTime;

        // A physical scanner sends characters within a few milliseconds of each
        // other, so only block keystrokes that arrive slowly (manual typing).
        // The very first keystroke (field currently empty) is always let through
        // so a scan burst never loses its first character.
        const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
        if (!isSlowManualKeystroke) {
            return;
        }

        e.preventDefault();
        setForm((prev) => ({ ...prev, bid: '' }));

        clearTimeout(clearBidTimerRef.current);
        clearBidTimerRef.current = setTimeout(() => {
            showManualEntryDisabledWarning();
        }, 300);
    };

    const handleBidFromPopupReadOnlyKeyDown = (e) => {
        if (!isReadOnly("bidFromPopup")) {
            return;
        }

        // Let native copy/paste behave normally (no custom clipboard handling).
        const isCopyOrPasteShortcut =
            (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
        if (isCopyOrPasteShortcut) {
            return;
        }

        if (e.key === 'Enter' || e.key === 'Tab') {
            return;
        }

        const currentTime = Date.now();
        const timeDiff = currentTime - lastBidFromPopupKeyTimeRef.current;
        lastBidFromPopupKeyTimeRef.current = currentTime;

        // A physical scanner sends characters within a few milliseconds of each
        // other, so only block keystrokes that arrive slowly (manual typing).
        // The very first keystroke (field currently empty) is always let through
        // so a scan burst never loses its first character.
        const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
        if (!isSlowManualKeystroke) {
            return;
        }

        e.preventDefault();
        setForm((prev) => ({ ...prev, bidFromPopup: '' }));

        clearTimeout(clearBidFromPopupTimerRef.current);
        clearBidFromPopupTimerRef.current = setTimeout(() => {
            showManualEntryDisabledWarning();
        }, 300);
    };

    useEffect(() => {
        return () => {
            clearTimeout(clearTimerRef.current);
            clearTimeout(clearBidTimerRef.current);
            clearTimeout(clearBidFromPopupTimerRef.current);
        };
    }, []);

    const [isDisabled, setIsDisabled] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsDisabled(true);
        setTimeout(() => setIsDisabled(false), 2000);

        if (!validate()) {
            focusFirstError();
            return;
        }
        if (!bsnVisible && isDuplicateIsbn && bsnVisibleForm?.isAuthorizedISBN === "3") {
            setForm((prev) => ({ ...prev, bidFromPopup: form?.bid, rackAndShelfpopUp: form?.rackAndShelf }));
            setBsnVisible(true);            
            return;
        }
        setBsnVisible(false);
        const submissionData = prepareSubmissionData();
        setLoading(true);

        try {
            const response = await fetch(CommonObj.Endpoints.SaveBookDetails, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(submissionData),
            });


            const result = await response.json();
            if (!response.ok) {
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            handleApiResponse(result, submissionData);

        } catch (error) {
            message.error({ content: error.message, duration: 5 });
        }
        finally {
            setLoading(false);
        }
    };


    const focusFirstError = () => {
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) {
            document.getElementById(firstErrorField)?.focus();
        }
    };

    const prepareSubmissionData = () => {
        return {
            bid: isDuplicateIsbn ? form.bidFromPopup : form.bid.trim(),
            isbn: form.isbn.trim(),
            isDuplicateIsbn: isDuplicateIsbn,
            rackShelf: isDuplicateIsbn ? form.rackAndShelfpopUp?.trim() : form.rackAndShelf.trim(),
            rackAndShelf: 1,
            title: form.title,
            author: form.author,
            publisher: form.publisher,
            isbN10: form.isbN10.trim(),
            isbN13: form.isbN13.trim(),
            pageCount: Number(form.bookPageCount),
            language: selectedLanguage,
            weight: form.weight || 0.75,
            format: form.bookFormat,
            condition: form.condition,
            usedCondition: form.usedCondition || '0',
            content: Array.isArray(form.content) ? form.content.join(",") : form.content,
            eqComplexityLevel: form.bookFormat !== "Exceptions" ? form.eqComplexityLevel : undefined,
            formatException: Number(form.reasonForException) || 0,
            version: form.version || "1.0",
            createdBy: roleUserId,
            bookCoverImageURL: bookCover,
            bookType: form.bookType,
            isAuthorizedISBN: bsnVisibleForm.isAuthorizedISBN,
            vendorID: Number(form.vendor) || 0,
            comments: form.comments || LogoText
        };
    };

    const isLanguageInactive = (langName) => {
        if (!langName || !Array.isArray(languageData)) return false;
        const matched = languageData.find(
            (ld) =>
                ld.languageName?.toLowerCase() === langName.toLowerCase() ||
                ld.languageCode?.toLowerCase() === langName.toLowerCase()
        );
        if (matched) {
            return (
                matched.status === "0"
            );
        }
        return false;
    };

    const handleApiResponse = (result, submissionData) => {
        if (!result.status) {
            const msg = result.message || "Failed to save the data";
            message.error(msg);
            return;
        }

        const isUnacceptable = submissionData.condition === "Used Condition" &&
            submissionData.usedCondition === "Unacceptable";

        let successMsg;

        if (isDuplicateIsbn) {
            successMsg = "Book status updated to Duplicate successfully and record transferred to MRBQ.";
        } else if (isUnacceptable) {
            successMsg = "Book intake cancelled due to unacceptable wear level";
        } else {
            successMsg = "Book Record Created Successfully.!";
        }

        message.success(successMsg);

        // Reset Form
        setIsbnInput('');
        setIsDuplicateIsbn(false);
        setForm(initialIntakeForm);
        setErrors({});
        setSelectedLanguage("");
        setVendorData([]);
    };

    async function fetchVendorsByIsbn(isbn, isDuplicate = false, hasMultiple = false) {
        try {
            const response = await fetch(CommonObj.Endpoints.GetVendorDetailsByISBN, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ isbn }),
            });
            if (!response.ok) {
                setVendorData([]);
                setForm((prev) => ({ ...prev, vendor: "" }));
                return;
            }
            const result = await response.json();
            const vendors = Array.isArray(result) ? result : result ? [result] : [];
            setVendorData(vendors);
            if (!hasMultiple && vendors.length > 0 && !isDuplicate) {
                setForm((prev) => ({ ...prev, vendor: String(vendors[0].vendorID) }));
            } else {
                setForm((prev) => ({ ...prev, vendor: "" }));
            }
        } catch (error) {
            console.error("Failed to fetch vendor data by ISBN:", error);
        }
    }

    async function UserLogin(isbn) {
        const url = CommonObj.Endpoints.Books;
        let pageName = { isbn: isbn , userID: roleUserId};
        setVendorData([]);
        setForm((prev) => ({ ...prev, vendor: "" }));
        setLoading(true);
        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(pageName),
            });
            if (!response.ok) {
                message.warning("Please enter Book details manually.");
                return false;
            }
            const result = await response.json();
            if (result.bookData) {
                setErrors({});
                setForm({
                    ...form,
                    bid: result.bookData.bid || form.bid,
                    title: result.bookData.title,
                    author: result.bookData.authors,
                    publisher: result.bookData.publisher,
                    isbN10: result.bookData.isbN_10,
                    isbN13: result.bookData.isbN_13,
                    bookPageCount: result.bookData.pageCount,
                    language: selectedLanguage,
                    weight: result.bookData.weight || "0.75",
                    isbn: isbn,
                    bookFormat: result.bookData.bookFormat || form.bookFormat,
                    condition: result.bookData.condition || form.condition,
                    usedCondition: result.bookData.usedCondition || form.usedCondition,
                    reasonForException:
                        result.bookData.reasonForException || form.reasonForException,
                    eqComplexityLevel:
                        result.bookData.eqComplexityLevel || form.eqComplexityLevel,
                    content: result.bookData.content || form.content,
                    rackShelf: form.rackShelf,
                    bookType: result.bookData.bookType || form.bookType,
                    version: result.bookData.version || form.version,
                });
                setBookCover(result.bookData.bookCoverImageURL);

                const code = result.bookData.language.toUpperCase();
                const languageMap = languageData.reduce((accumulator, item) => {
                    if (item.languageCode) {
                        accumulator[item.languageCode.toUpperCase()] = item.languageName;
                    }
                    return accumulator;
                }, {});
                const matchedLabel = languageMap[code];
                if (matchedLabel) {
                    setSelectedLanguage(matchedLabel);
                }

                setBsnVisibleForm({
                    bid: result.bookData.bid || bsnVisibleForm.bid,
                    isbn: isbnInput,
                    version: result.bookData.version || form.version,
                    rackAndShelf: 1,
                    title: result.bookData.title || bsnVisibleForm.title,
                    author: result.bookData.authors || bsnVisibleForm.author,
                    publisher: result.bookData.publisher,
                    isbN10: result.bookData.isbN_10,
                    isbN13: result.bookData.isbN_13,
                    pageCount: result.bookData.pageCount,
                    language: selectedLanguage,
                    weight: result.bookData.weight || "0.75",
                    format: result.bookData.bookFormat || form.bookFormat,
                    condition: result.bookData.condition || form.condition,
                    usedCondition: result.bookData.usedCondition || form.usedCondition,
                    //content: result.bookData.content || form.content,
                    content: Array.isArray(form.content)
                        ? form.content.join(",")
                        : form.content,
                    eqComplexityLevel: result.bookData.eqComplexityLevel || form.eqComplexityLevel,
                    createdBy: roleUserId,
                    formatException: Number(form.reasonForException) || 0,
                    rackShelf: form.rackShelf,
                    bookCoverImageURL: result.bookData.bookCoverImageURL,
                    bookType: result.bookData.bookType || form.bookType,
                    updatedPageCount: 0
                });
            }
            const isbnStatus = await IsValidISBN(isbn);
            await fetchVendorsByIsbn(isbn, isbnStatus.isDuplicate, isbnStatus.hasMultiple);
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <Spin size="large" style={{ margin: "20px auto", opacity: "0.8" }} />
        );
    }

    async function IsValidISBN(isbn) {
        const url = CommonObj.Endpoints.GetISBNStatus;
        const defaultStatus = { hasMultiple: false, isDuplicate: false };

        setLoading(true);
        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(isbn.trim()),
            });
            if (!response.ok) {
                message.warning("Please enter Book details manually.");
                return defaultStatus;
            }
            const result = await response.json();
            let isDuplicate = false;
            if (result?.length > 0 && result[0].isAuthorizedISBN === "0") {
                setBsnVisible(true);
                setIsDuplicateIsbn(false);
                isDuplicate = false;
            } else if (result[0].isAuthorizedISBN === "2") {
                message.warning("This book has already been moved to the Exception Queue");
                setIsbnInput('');
                setForm(initialIntakeForm);
                setBsnVisibleForm(initialBSNForm);
                setErrors({});
                setSelectedLanguage("");
                setIsDuplicateIsbn(false);
                setVendorData([]);
                isDuplicate = false;
            } else if (result[0].isAuthorizedISBN === "3") {
                const errorMsg = result[0].message || "This ISBN cannot be processed at this time";
                message.error(errorMsg);
                setIsDuplicateIsbn(true);
                setForm((prev) => ({ ...prev, vendor: "" }));
                isDuplicate = true;
            } else {
                setIsDuplicateIsbn(false);
                isDuplicate = false;
            }
            setBsnVisibleForm(prev => ({ ...prev, isAuthorizedISBN: result[0].isAuthorizedISBN }));
            return {
                hasMultiple: Boolean(result[0]?.hasMultipleVendor),
                isDuplicate,
            };
        } catch (error) {
            console.error(error.message);
            return defaultStatus;
        } finally {
            setLoading(false);
        }
    }

    async function SaveUnauthorziedISBN() {
        const url = CommonObj.Endpoints.SaveUnauthorziedBookIntake;

        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(bsnVisibleForm),
            });
            if (!response.ok) {
                message.warning("Please enter Book details manually.");
            }
            const getResp = await response.json();
            if (getResp.status && getResp.message === "Success") {
                message.success("Book successfully moved to the Exception Queue.");
            } else if (!getResp.status && getResp.message === "BID already exists") {
                message.error("BID already exists.");
                setBsnVisible(true);
                return;
            }
            setBsnVisible(false);
            setIsbnInput('');
            setForm(initialIntakeForm);
            setBsnVisibleForm(initialBSNForm);
            setErrors({});
            setRackShelfpopUp("");
            setSelectedLanguage("");
            setIsDuplicateIsbn(false);
            setVendorData([]);
        } catch (error) {
            console.error(error.message);
            return false;
        }
    }

    const handleBlur = (e) => {
        setHasUserInteracted(true);

        const name = e.target.name;
        const value = form[name]?.trim();
        const allowedCharactersRegex = /^[0-9\s-]*$/;
        if (name === 'bid') {
            const errorMessage = validateBid(value);
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: errorMessage,
            }));
            if (!errorMessage && value) {
                checkIntakeBidStatus(value);
            }
        }

        if (e.target.name === 'isbn' && form.isbn.trim() !== '' && allowedCharactersRegex.test(form.isbn)) {
            UserLogin(form.isbn.trim());
        }
    };

    const validateBid = (value) => validationService.validateBid(value);

    async function checkIntakeBidStatus(bid) {
        const url = CommonObj.Endpoints.GetIntakeBidStatus;
        setIsDisabled(true);
        setTimeout(() => setIsDisabled(false), 2000);
        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ bid: bid }),
            });
            if (!response.ok) throw new Error(`Response status: ${response.status}`);
            const result = await response.json();
            if (result && result.isAuthorizedBID === "1") {
                message.error(result.message || "BID already exists");
                setForm((prev) => ({ ...prev, bid: "" }));
                setErrors((prev) => ({ ...prev, bid: "" }));
                return true;
            }
        } catch (error) {
            console.error(error.message);
        }
        return false;
    }

    const handleIsbnInputChange = (e) => {
        const value = e.target.value.replace(/\s/g, '');
        setIsbnInput(value);
        // Immediately clear all populated data when ISBN is removed
        if (value.trim() === '') {
            setForm(initialIntakeForm);
            setBookCover('');
            setSelectedLanguage("");
            setErrors({});
            setIsDuplicateIsbn(false);
            setVendorData([]);
        }
    };

    const handleConfirm = (e) => {
        const newErrors = {};
        if (!form.rackAndShelfpopUp || !form.rackAndShelfpopUp?.trim()) {
            newErrors.rackAndShelfpopUp = "Rack and Shelf is required";
        }
        else if (regexLoaded) {
            const validation = regexService.validateRackShelf(form.rackAndShelfpopUp.trim());
            if (!validation.isValid) {
                newErrors.rackAndShelfpopUp = "Input format invalid: No matching pattern found.";
            }
        }
        const bidError = validationService.validateBid(form.bidFromPopup);
        if (!form.bidFromPopup || !form.bidFromPopup.trim()) {
            newErrors.bidFromPopup = isDuplicateIsbn ? "BID# is required":"BID# is required for this exception.";
        } else if (bidError) {
            newErrors.bidFromPopup = bidError;
        }

        if (Object.keys(newErrors).length !== 0) {
            setErrors(newErrors);
            setBsnVisible(true);
            return;
        }

        if (bsnVisibleForm?.isAuthorizedISBN === "3") {
            handleSubmit(e);
        }
        else if (bsnVisibleForm?.isAuthorizedISBN === "0") {
            //form.rackAndShelf = rackShelfpopUp;
            bsnVisibleForm.rackShelf = form.rackAndShelfpopUp;
            bsnVisibleForm.bid = form.bidFromPopup;
            SaveUnauthorziedISBN();
        }

    };
    const getInputClass = (value, baseClass = "book-page-form-input-text") => {
        const hasValue =
            value !== null &&
            value !== undefined &&
            (typeof value === "number" || String(value).trim() !== "");

        return `${baseClass}${hasValue ? " has-text" : ""}`;
    };
    const showRejectModal = (record) => {
        if (!validate()) {
            focusFirstError();
            return;
        }
        const submissionData = prepareSubmissionData();
        setIsModalVisible(true);
        setRejectSubmissionData(submissionData);
    };
    const clearForm = () => {
        setIsbnInput('');
        setForm(initialIntakeForm);
        setErrors({});
        setSelectedLanguage("");
        setIsDuplicateIsbn(false);
        setVendorData([]);
    }
    return (
        <>
            <IntakeSlide
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                clearForm={clearForm}
                title={"Intake Reject"}
                rejectSubmissionData={rejectSubmissionData}
                oldRackandShelf={rejectSubmissionData?.rackShelf}
                onScannerOpen={(scanner) => { setActiveScanner(scanner) }}
                emptyDecode={() => { setDecodedResults([]) }}
                className="story-slider slider-with-footer"
                width={540}
            />
            
            <Modal
                title={isDuplicateIsbn ? <></> : `STOP!`}
                open={bsnVisible}
                footer={null}
                className="recycle-manifest-model stop-modal"
                width={760}
            >
                <img src={ConfirmationModalStopImg} alt="Modal Stop" className="modal-header-img"></img>
                <span style={{ width: "100%", textAlign: "center" }}>
                    {isDuplicateIsbn
                        ? <div className="justifySpace">This is a duplicate ISBN, kindly move to MRBQ</div>
                        : <>This book is not listed as purchased, and will be moved to <strong>EXCEPTION RACK. Please Scan/Enter the Rack</strong> to proceed!</>
                    }
                </span>
                <div className="book-page-form-scan-rack-container">
                    <span className="form-required-rack">*</span>
                    <input
                        className="book-page-form-scan-rack-button"
                        id="bidFromPopup"
                        name="bidFromPopup"
                        placeholder={isReadOnly("bidFromPopup") ? "Scan BID" : "Enter / Scan BID"}
                        onChange={(e) => {
                            handleChangpopUp(e);
                        }}
                        onKeyDown={handleBidFromPopupReadOnlyKeyDown}

                        value={form.bidFromPopup || ""}
                        readOnly={isDuplicateIsbn}
                    ></input>
                    <button
                        className="book-page-form-scan-rack-button-icon"
                        data-track="books-open-bid-popup-scanner"
                        style={{ display: isDuplicateIsbn ? 'none' : 'block' }} // or 'flex' depending on your CSS
                        onClick={() => {
                            if (!isDuplicateIsbn) {
                                setDecodedResults([]);
                                setActiveScanner("BID Popup");
                            }
                        }}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="12"
                                cy="13"
                                r="3"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                            />
                            <path
                                opacity="0.5"
                                d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                            />
                            <path
                                d="M18 10H17.5"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                opacity="0.5"
                                d="M14.5 3.5H9.5"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                fill="url(#paint0_linear_1086_13736)"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                fill="url(#paint1_linear_1086_13736)"
                            />
                            <defs>
                                <linearGradient
                                    id="paint0_linear_1086_13736"
                                    x1="22.601"
                                    y1="11.9503"
                                    x2="1.98296"
                                    y2="14.3301"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#033D9B" />
                                    <stop offset="1" stopColor="#29ACD5" />
                                </linearGradient>
                                <linearGradient
                                    id="paint1_linear_1086_13736"
                                    x1="22.601"
                                    y1="11.9503"
                                    x2="1.98296"
                                    y2="14.3301"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#033D9B" />
                                    <stop offset="1" stopColor="#29ACD5" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </button>
                    <span className="error-msg-rad">{errors.bidFromPopup}</span>
                </div>
                <div className="book-page-form-scan-rack-container">
                    <span class="form-required-rack">*</span>
                    <input
                        className="book-page-form-scan-rack-button"
                        id="rackAndShelfpopUp"
                        name="rackAndShelfpopUp"
                        placeholder="Enter / Scan Rack Shelf Barcode"
                        onChange={handleChangpopUp}
                        value={form.rackAndShelfpopUp || ""}
                       
                    ></input>
                    <button
                        className="book-page-form-scan-rack-button-icon"
                        data-track="books-open-rack-popup-scanner"
                        onClick={() => {
                                setDecodedResults([]);
                                setActiveScanner("Rack & Shelf Popup");
                        }}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="12"
                                cy="13"
                                r="3"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                            />
                            <path
                                opacity="0.5"
                                d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                            />
                            <path
                                d="M18 10H17.5"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                opacity="0.5"
                                d="M14.5 3.5H9.5"
                                stroke="#1C274C"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                fill="url(#paint0_linear_1086_13736)"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                fill="url(#paint1_linear_1086_13736)"
                            />
                            <defs>
                                <linearGradient
                                    id="paint0_linear_1086_13736"
                                    x1="22.601"
                                    y1="11.9503"
                                    x2="1.98296"
                                    y2="14.3301"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#033D9B" />
                                    <stop offset="1" stopColor="#29ACD5" />
                                </linearGradient>
                                <linearGradient
                                    id="paint1_linear_1086_13736"
                                    x1="22.601"
                                    y1="11.9503"
                                    x2="1.98296"
                                    y2="14.3301"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#033D9B" />
                                    <stop offset="1" stopColor="#29ACD5" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </button>
                    <span className="error-msg-rad">{errors.rackAndShelfpopUp}</span>
                </div>
                <div className="book-page-buttons-container justify-space">
                    {isDuplicateIsbn ? 
                    <button type="button" 
                        className="reject-button"
                        onClick={()=>{
                            setBsnVisible(false)
                            setForm((prev) => ({ ...prev, rackAndShelfpopUp: "" }));
                            }}
                    >Cancel</button>:""}
                    <button className="accept-button" data-track={isDuplicateIsbn ? "intake-MRBQ-submit" : "intake-unauthorizedBook-submit"} style={isDuplicateIsbn ? { margin: "0",width: "auto" } : {}} type="submit" onClick={handleConfirm}>{isDuplicateIsbn ? <div style={{whiteSpace:"nowrap"}}>Move to MRBQ</div>:"Proceed"}</button>
                </div>
            </Modal>

            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => setActiveScanner(null)}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}

            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <SliderUI
                visible={visible}
                width={390}
                title="Book Slide"
                onClose={() => setVisible(false)}
                imageSrc={bookCover ? bookCover : BookCoverDummy}
                bookTitle={form.title}
                isbn={form.isbn}
                bid={form.bid}
                bookscover={true}
                className="story-slider"
            />
            <SliderUI
                visible={commentsvisible}
                width={390}
                title="Comments Slide"
                onClose={() => setCommentsVisible(false)}
                bookTitle={`Comments For BID : ${form.bid}`}
                commentsList={commentsList}
                username={form.createdBy}
                form={form}
                setForm={setForm}
                saveComment={saveComment}
                load={load}
                className="story-slider"
            />



            {/* <Drawer
        visible={commentsvisible}
        width={320}
        title="Comments"
        onClose={() => setCommentsVisible(false)}
      >
        <div style={{ padding: 16 }}>
          <div>
            <strong>Comments for BID: {currentBidForComments}</strong>
            <div
              style={{
                margin: "10px 0",
                maxHeight: "180px",
                overflowY: "auto",
              }}
            >
              {commentsList.length > 0 ? (
                commentsList?.map((comment, idx) => (
                  <div
                    key={idx}
                    style={{
                      marginBottom: 8,
                      background: "#f4f4f4",
                      padding: 8,
                      borderRadius: 3,
                    }}
                  >
                    {comment?.comments}
                  </div>
                ))
              ) : (
                <div>No Existing Comments</div>
              )}
            </div>
            <Input.TextArea
              rows={2}
              value={form.comments}
              placeholder="Enter your comment..."
              onChange={(e) =>
                setForm((prev) => ({ ...prev, comments: e.target.value }))
              }
              style={{ marginBottom: 8 }}
            />
            <Button type="primary" block onClick={saveComment}>
              Post Comment
            </Button>
          </div>
        </div>
      </Drawer> */}
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container">
                        <div className="book-page-title">
                            <span>
                                <img src={BookShelf} alt="BookShelf Icon"></img>
                            </span>
                            <h2>Begin The Intake Process</h2>
                        </div>
                        <button className="book-page-title-icon" onClick={() => setVisible(true)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4 6V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H4ZM4 6V5"
                                    stroke="#0009E2"
                                    strokeWidth="1.5"
                                />
                                <circle
                                    opacity="0.5"
                                    cx="12"
                                    cy="13"
                                    r="3"
                                    stroke="#009DDB"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M18 6.00002V6.75002H18.75V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619H4.81353L4.91959 3.86865ZM5.07107 6.00002V6.75002H18V6.00002V5.25002H5.07107V6.00002ZM18 6.00002H18.75V4.30604H18H17.25V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L4.81353 3.12619L4.91959 3.86865L5.02566 4.61111L15.8232 3.0686L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619C3.91638 3.25435 3.25 4.0227 3.25 4.92895H4H4.75C4.75 4.76917 4.86749 4.63371 5.02566 4.61111L4.91959 3.86865ZM18 4.30604H18.75C18.75 2.63253 17.2678 1.34701 15.6111 1.58368L15.7172 2.32614L15.8232 3.0686C16.5763 2.96103 17.25 3.54535 17.25 4.30604H18ZM5.07107 6.00002V5.25002C4.89375 5.25002 4.75 5.10627 4.75 4.92895H4H3.25C3.25 5.9347 4.06532 6.75002 5.07107 6.75002V6.00002Z"
                                    fill="#0009E2"
                                />
                                <path
                                    opacity="0.5"
                                    d="M10 19H14"
                                    stroke="#009DDB"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>
                    <form className="book-page-form" onSubmit={handleSubmit} noValidate onKeyDown={(e) => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') { e.preventDefault(); } }}>
                        <div className="book-page-camera-button-container multiple">
                            <Input
                                placeholder=""
                                value={isbnInput.trim()}
                                className={`${isbnInput ? "has-id" : ""}`}
                                onChange={(e) => {
                                    handleIsbnInputChange(e);
                                }}
                                onBlur={handleIsbnBlur}
                                onKeyDown={handleIsbnReadOnlyKeyDown}
                                onKeyPress={handleIsbnKeyPress}
                                id="isbninput-bokks-1"
                            // onClick={() => { if (isReadOnly("isbn")){setDecodedResults([]); setActiveScanner("ISBN");}}}
                            />
                            {isbnInput.length === 0 && (
                                <label htmlFor="isbninput-bokks-1">
                                    {isReadOnly("isbn") ? "Scan " : "Enter / Scan "}ISBN Number Using “<strong>Camera Icon</strong>”<span className="form-required"> *</span>
                                </label>
                            )}
                            <button
                                type="button"
                                className="book-page-camera-button"
                                data-track="books-open-isbn-scanner"
                                onClick={() => { setDecodedResults([]); setActiveScanner("ISBN") }}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                        fill="url(#paint0_linear_273_6917)"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                        fill="url(#paint1_linear_273_6917)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <button
                                type="button"
                                className="book-page-camera-button-input-2"
                                //onClick={handleSubmitIsbn}
                                onClick={handleIsbnBlur}
                                disabled={isbnSubmitButton}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                        fill="url(#paint0_linear_1900_8687)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_1900_8687"
                                            x1="20.6"
                                            y1="9.94475"
                                            x2="-0.0696504"
                                            y2="12.0919"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                        </div>

                        <div className="book-page-form-container">
                            <div className="book-page-form-1">
                                <div className="field-group">
                                    <input
                                        id="bid"
                                        name="bid"
                                        className={getInputClass(form?.bid)}
                                        // onClick={() => { if (isReadOnly("bid")) { setDecodedResults([]); setActiveScanner("BID"); } }}
                                        // onFocus={() => {
                                        //     if (isReadOnly("bid")) {
                                        //         showManualEntryDisabledWarning();
                                        //     }
                                        // }}
                                        value={form.bid}
                                        onBlur={handleBlur}

                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        onKeyDown={handleBidReadOnlyKeyDown}
                                        onKeyPress={handleBidKeyPress}

                                        required
                                    />
                                    <label htmlFor="bid" className="label">
                                        {isReadOnly("bid") ? "Scan " : "Enter / Scan "}Book ID (BID) <span className="form-required">*</span>
                                    </label>
                                    <button
                                        className="book-page-form-input-camera-icon"
                                        data-track="books-open-bid-field-scanner"
                                        type="button"
                                        onClick={() => { setDecodedResults([]); setActiveScanner("BID") }}
                                    >
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle cx="8" cy="8.66669" r="2" stroke="#1C274C" />
                                            <path
                                                opacity="0.5"
                                                d="M6.66673 13.3333H9.3334C11.206 13.3333 12.1423 13.3333 12.8149 12.8839C13.1061 12.6894 13.3561 12.4393 13.5507 12.1482C14.0001 11.4756 14.0001 10.5393 14.0001 8.66666C14.0001 6.79404 14 5.85788 13.5506 5.18528C13.356 4.89411 13.106 4.64411 12.8148 4.44955C12.1422 4.00014 11.2059 4.00014 9.3333 4.00014H6.66663C4.79402 4.00014 3.85771 4.00014 3.18511 4.44955C2.89394 4.64411 2.64394 4.89411 2.44938 5.18528C2.00007 5.85773 2.00007 6.79363 2.00007 8.66542L2.00007 8.66666C2.00007 10.5393 2.00007 11.4756 2.44948 12.1482C2.64404 12.4393 2.89404 12.6894 3.18521 12.8839C3.85781 13.3333 4.79412 13.3333 6.66673 13.3333Z"
                                                stroke="#1C274C"
                                            />
                                            <path
                                                d="M12.0001 6.66669H11.6667"
                                                stroke="#1C274C"
                                                strokeLinecap="round"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M9.66659 2.33331H6.33325"
                                                stroke="#1C274C"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M5.33398 2.66667C5.33398 2.29848 5.6095 2 5.94937 2H10.0519C10.3918 2 10.6673 2.29848 10.6673 2.66667C10.6673 3.03486 10.3918 3.33333 10.0519 3.33333H5.94937C5.6095 3.33333 5.33398 3.03486 5.33398 2.66667Z"
                                                fill="url(#paint0_linear_1086_13749)"
                                            />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M6.51917 14H9.48213C11.5628 14 12.6032 14 13.3505 13.5185C13.674 13.31 13.9518 13.0422 14.168 12.7302C14.6673 12.0095 14.6673 11.0063 14.6673 8.99992C14.6673 6.99352 14.6672 5.99047 14.1679 5.26982C13.9517 4.95784 13.6739 4.68998 13.3504 4.48152C12.603 4 11.5627 4 9.48202 4H6.51906C4.43837 4 3.39803 4 2.6507 4.48152C2.32718 4.68998 2.0494 4.95784 1.83322 5.26982C1.33398 5.99031 1.33398 6.99307 1.33398 8.99859L1.33398 8.99992C1.33398 11.0063 1.33398 12.0095 1.83333 12.7302C2.04951 13.0422 2.32729 13.31 2.65081 13.5185C3.39814 14 4.43848 14 6.51917 14ZM5.22287 8.99992C5.22287 7.52056 6.46653 6.32131 8.00065 6.32131C9.53478 6.32131 10.7784 7.52056 10.7784 8.99992C10.7784 10.4793 9.53478 11.6785 8.00065 11.6785C6.46653 11.6785 5.22287 10.4793 5.22287 8.99992ZM6.33398 8.99992C6.33398 8.11231 7.08018 7.39275 8.00065 7.39275C8.92113 7.39275 9.66732 8.11231 9.66732 8.99992C9.66732 9.88754 8.92113 10.6071 8.00065 10.6071C7.08018 10.6071 6.33398 9.88754 6.33398 8.99992ZM12.0747 6.32131C11.7679 6.32131 11.5192 6.56116 11.5192 6.85703C11.5192 7.1529 11.7679 7.39275 12.0747 7.39275H12.4451C12.7519 7.39275 13.0007 7.1529 13.0007 6.85703C13.0007 6.56116 12.7519 6.32131 12.4451 6.32131H12.0747Z"
                                                fill="url(#paint1_linear_1086_13749)"
                                            />
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_1086_13749"
                                                    x1="15.0673"
                                                    y1="7.96685"
                                                    x2="1.32197"
                                                    y2="9.55339"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                                <linearGradient
                                                    id="paint1_linear_1086_13749"
                                                    x1="15.0673"
                                                    y1="7.96685"
                                                    x2="1.32197"
                                                    y2="9.55339"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </button>
                                    {errors.bid && (
                                        <span className="error-msg">{errors.bid}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="main-isbn"
                                        name="isbn"
                                        className={getInputClass(form?.isbn)}
                                        value={form.isbn}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        required
                                        readOnly={isReadOnly("isbn")}
                                    />
                                    <label htmlFor="main-isbn" className="label">
                                        Book Number (ISBN) <span className="form-required">*</span>
                                    </label>
                                    {errors.isbn && (
                                        <span className="error-msg">{errors.isbn}</span>
                                    )}
                                </div>

                                <div className="field-group" hidden>
                                    <input
                                        id="version"
                                        name="version"
                                        className={getInputClass(form?.version)}
                                        value={form.version}
                                        hidden
                                    />
                                    <label htmlFor="version" className="label" hidden>
                                        Version
                                    </label>
                                    {/*{errors.version && (*/}
                                    {/*  <span className="error-msg">{errors.version}</span>*/}
                                    {/*)}*/}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="isbN10"
                                        name="isbN10"
                                        className={getInputClass(form?.isbN10)}
                                        value={form.isbN10}
                                        onChange={handleChange}
                                        readOnly={isReadOnly("isbN10")}
                                    />
                                    <label htmlFor="isbN10" className="label">
                                        ISBN-10 <span className="form-required">*</span>
                                    </label>
                                    {errors.isbN10 && (
                                        <span className="error-msg">{errors.isbN10}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="isbN13"
                                        name="isbN13"
                                        className={getInputClass(form?.isbN13)}
                                        value={form.isbN13}
                                        onChange={handleChange}
                                        readOnly={isReadOnly("isbN13")}
                                    />
                                    <label htmlFor="isbN13" className="label">
                                        ISBN-13 <span className="form-required">*</span>
                                    </label>
                                    {errors.isbN13 && (
                                        <span className="error-msg">{errors.isbN13}</span>
                                    )}
                                </div>

                                {form.bookFormat !== "Exceptions" && (
                                    <div className="field-group">
                                        <select
                                            id="eqComplexityLevel"
                                            name="eqComplexityLevel"
                                            className={getInputClass(form?.eqComplexityLevel)}
                                            value={form.eqComplexityLevel || ""}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value=""></option>
                                            <option value="1A">1A</option>
                                            <option value="2A">2A</option>
                                            <option value="3A">3A</option>
                                            <option value="4A">4A</option>
                                            <option value="5A">5A</option>
                                            <option value="1B">1B</option>
                                            <option value="2B">2B</option>
                                            <option value="3B">3B</option>
                                            <option value="4B">4B</option>
                                            <option value="5B">5B</option>
                                        </select>
                                        <label htmlFor="eqComplexityLevel" className="label">
                                            EQ-Complexity Level{" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        {errors.eqComplexityLevel && (
                                            <span className="error-msg">
                                                {errors.eqComplexityLevel}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="book-page-form-2">
                                <div className="field-group">
                                    <input
                                        id="title"
                                        name="title"
                                        className={getInputClass(form?.title)}
                                        value={form.title}
                                        onChange={handleChange}
                                        readOnly={isReadOnly("title")}
                                    />
                                    <label htmlFor="title" className="label">
                                        Title <span className="form-required">*</span>
                                    </label>
                                    {errors.title && (
                                        <span className="error-msg">{errors.title}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="author"
                                        name="author"
                                        className={getInputClass(form?.author)}
                                        value={form.author}
                                        onChange={handleChange}
                                        readOnly={isReadOnly("author")}
                                    />
                                    <label htmlFor="author" className="label">
                                        Author <span className="form-required">*</span>
                                    </label>
                                    {errors.author && (
                                        <span className="error-msg">{errors.author}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="publisher"
                                        name="publisher"
                                        className={getInputClass(form?.publisher)}
                                        value={form.publisher}
                                        onChange={handleChange}
                                        readOnly={isReadOnly("publisher")}
                                    />
                                    <label htmlFor="publisher" className="label">
                                        Publisher <span className="form-required">*</span>
                                    </label>
                                    {errors.publisher && (
                                        <span className="error-msg">{errors.publisher}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="bookPageCount"
                                        name="bookPageCount"
                                        className={getInputClass(form?.bookPageCount)}
                                        type="number"
                                        value={form.bookPageCount}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        min="0"
                                        readOnly={isReadOnly("bookPageCount")}
                                    />
                                    <label htmlFor="bookPageCount" className="label">
                                        Page Count <span className="form-required">*</span>
                                    </label>
                                    {errors.bookPageCount && (
                                        <span className="error-msg">{errors.bookPageCount}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <select
                                        id="language"
                                        name="language"
                                        className={`book-page-form-input-text ${selectedLanguage ? "has-text" : ""}`}
                                        value={selectedLanguage}
                                        onChange={handleLanguageChange}
                                        required
                                    >
                                        <option value=""></option>
                                        {isSelectedMissingFromMaster && (
                                            <option value={selectedLanguage} disabled>
                                                {selectedLanguage}
                                            </option>
                                        )}

                                        {masterData.language.map((language) => {
                                            const isInactive = isLanguageInactive(language.languageName);
                                            const isCurrentlySelected = selectedLanguage === language.languageName;
                                            return (
                                                <option
                                                    key={language.languageName}
                                                    value={language.languageName || selectedLanguage}
                                                    disabled={language.status == 0}
                                                >
                                                    {language.languageName}

                                                </option>
                                            );
                                        })}
                                    </select>

                                    <label htmlFor="language" className="label">
                                        Language <span className="form-required">*</span>
                                    </label>
                                    {errors.language && !langErrorMsg && (
                                        <span className="error-msg">{errors.language}</span>
                                    )}
                                    {langErrorMsg && (
                                        <span className="error-msg">{langErrorMsg}</span>
                                    )}
                                </div>
                            </div>

                            <div className="book-page-form-3">
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">Condition<span className="form-required">*</span></p>
                                    <div className="book-page-form-radio-button-container">
                                        <div className="book-page-form-radio-button">
                                            <input
                                                type="radio"
                                                name="condition"
                                                id="book-page-form-radio-new-book"
                                                value="New Book"
                                                checked={form.condition === "New Book"}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="book-page-form-radio-new-book">
                                                New Book
                                            </label>
                                        </div>
                                        <div className="book-page-form-radio-button">
                                            <input
                                                type="radio"
                                                name="condition"
                                                id="book-page-form-radio-used-book"
                                                value="Used Condition"
                                                checked={form.condition === "Used Condition"}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="book-page-form-radio-used-book">
                                                Used Condition
                                            </label>
                                        </div>
                                    </div>
                                    {errors.condition && (
                                        <span className="error-msg-rad">{errors.condition}</span>
                                    )}
                                </div>
                                {form.condition === "Used Condition" && (
                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">Wear Level <span className="form-required">*</span> </p>
                                        <div className="book-page-form-radio-button-container">
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    id="used-condition-acceptable"
                                                    name="usedCondition"
                                                    value="Acceptable"
                                                    checked={form.usedCondition === "Acceptable"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="used-condition-acceptable">
                                                    Acceptable
                                                </label>
                                            </div>

                                            <div className="book-page-form-radio-button" style={{ display: 'none' }}>
                                                <input
                                                    type="radio"
                                                    id="used-condition-unacceptable"
                                                    name="usedCondition"
                                                    value="Unacceptable"
                                                    checked={form.usedCondition === "Unacceptable"}
                                                    onChange={handleChange}
                                                    style={{ cursor:"no-drop" }}
                                                    hidden
                                                />
                                                <label htmlFor="used-condition-unacceptable">
                                                    Unacceptable
                                                </label>
                                            </div>
                                        </div>
                                        {errors.usedCondition && (
                                            <span className="error-msg-rad">
                                                {errors.usedCondition}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">Binding<span className="form-required">*</span></p>
                                    <div className="book-page-form-radio-button-container">
                                        <div className="book-page-form-radio-button">
                                            <input
                                                type="radio"
                                                name="bookType"
                                                id="book-page-form-radio-text-book"
                                                value="Textbook"
                                                checked={form.bookType === "Textbook"}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="book-page-form-radio-text-book">
                                                Textbook
                                            </label>
                                        </div>
                                        <div className="book-page-form-radio-button">
                                            <input
                                                type="radio"
                                                name="bookType"
                                                id="book-page-form-radio-grade-book"
                                                value="Tradebook"
                                                checked={form.bookType === "Tradebook"}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="book-page-form-radio-grade-book">
                                                Tradebook
                                            </label>
                                        </div>
                                    </div>
                                    {errors.bookType && (
                                        <span className="error-msg-rad">{errors.bookType}</span>
                                    )}
                                </div>
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">Book Type <span className="form-required">*</span></p>
                                    <div className="book-page-form-radio-button-container">
                                        {masterData.bookFormat.map((item) => item.format !== "Exceptions"&& (
                                            <div
                                                key={item.id}
                                                className="book-page-form-radio-button"
                                            >
                                                <input
                                                    type="radio"
                                                    name="bookFormat"
                                                    id={`book-format-${item.id}`}
                                                    value={item.format}
                                                    checked={form.bookFormat === item.format}
                                                    onChange={handleChange}
                                                    style={{
                                                        cursor: (item.format === "Exceptions" || form?.bookFormat === "Exceptions")
                                                            ? "not-allowed"
                                                            : "auto"
                                                    }}
                                                    disabled={item.format === "Exceptions" || form?.bookFormat === "Exceptions"}
                                                />
                                                <label htmlFor={`book-format-${item.id}`}>
                                                    {item.format}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.bookFormat && (
                                        <span className="error-msg-rad">{errors.bookFormat}</span>
                                    )}
                                </div>

                                {form.bookFormat === "Exceptions" && (
                                    <div className="field-group" style={{ display: 'none' }}>
                                        <select
                                            id="reasonForException"
                                            name="reasonForException"
                                            className={getInputClass(form?.reasonForException)}
                                            value={form.reasonForException}
                                            onChange={handleChange}
                                            //required
                                            disabled
                                            style={{ cursor: "not-allowed;" }}
                                            hidden
                                        >
                                            <option value=""></option>

                                            {masterData.bookFormatExceptions.map((exception) => (
                                                <option key={exception.id} value={exception.id}>
                                                    {exception.exceptionType}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="reasonForException" className="label">
                                            Reason for Exception{" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        {errors.reasonForException && (
                                            <span className="error-msg">
                                                {errors.reasonForException}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="book-page-form-checkbox-container">
                                    <p className="book-page-form-checkbox-title">Content <span className="form-required">*</span></p>
                                    <div className="book-page-form-checkbox-button-container">
                                        {masterData.condition.map((item) => (
                                            <div
                                                key={item.id}
                                                className="book-page-form-checkbox-button"
                                            >
                                                <input
                                                    type="checkbox"
                                                    name="content"
                                                    id={`content-${item.id}`}
                                                    value={item.fileType}
                                                    checked={form.content.includes(item.fileType)}
                                                    onChange={handleContentChange}
                                                />
                                                <label htmlFor={`content-${item.id}`}>
                                                    {item.fileType}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.content && (
                                        <span className="error-msg-rad">{errors.content}</span>
                                    )}
                                </div>

                                <input
                                    id="weight"
                                    name="weight"
                                    className={`${"book-page-form-input-text hidden-input"} ${form.weight === "" ? "" : "has-text"
                                        }`}
                                    type="number"
                                    value={form.weight}
                                    onChange={handleChange}
                                    placeholder="Weight (grams)"
                                    hidden
                                />
                                <div className="book-page-form-scan-rack-container">
                                    <input
                                        className="book-page-form-scan-rack-button"
                                        id="rackAndShelf"
                                        name="rackAndShelf"
                                        placeholder="Enter / Scan Rack Shelf Barcode"
                                        // className={`${"book-page-form-input-text"} ${
                                        //   form.rackAndShelf === "" ? "" : "has-text"
                                        // }`}
                                        value={form.rackAndShelf}
                                        onChange={handleChange}
                                        required
                                    ></input>
                                    <button
                                        className="book-page-form-scan-rack-button-icon"
                                        data-track="books-open-rack-scanner"
                                        type="button"
                                        onClick={() => { setDecodedResults([]); setActiveScanner("Rack & Shelf ID") }}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="12"
                                                cy="13"
                                                r="3"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                d="M18 10H17.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M14.5 3.5H9.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                                fill="url(#paint0_linear_1086_13736)"
                                            />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                                fill="url(#paint1_linear_1086_13736)"
                                            />
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_1086_13736"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                                <linearGradient
                                                    id="paint1_linear_1086_13736"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </button>
                                    <span className="error-msg-rad">{errors.rackAndShelf}</span>
                                </div>
                                <div className="field-group">
                                    <select
                                        id="vendor"
                                        name="vendor"
                                        className={`book-page-form-input-text ${form.vendor ? "has-text" : ""}`}
                                        value={form.vendor}
                                        onChange={handleVendorChange}
                                    >
                                        <option value=""></option>
                                        {vendorData.map((v) => (
                                            <option key={v.vendorID} value={String(v.vendorID)}>
                                                {v.vendorName}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="vendor" className="label">
                                        Vendor <span className="form-required">*</span>
                                    </label>
                                    {errors.vendor && (
                                        <span className="error-msg">{errors.vendor}</span>
                                    )}
                                                           {isDuplicateIsbn ? <div className="error-msg" style={{paddingTop: "30px"}}>Duplicate ISBN identified. You may continue entering details to route this item to the MRBQ.</div>:<></>}
                                </div>
                            </div>

                            <div className="book-page-form-4">
                                <div className="field-group">
                                    {/* <a
                    href="javascript:void(0)"
                    className="book-page-form-view-comments"
                    onClick={() => openCommentsSlider(form.bid)}
                  >
                    View Comments (0)
                  </a> */}
                                    <textarea
                                        id="comments"
                                        rows="4"
                                        value={form.comments}
                                        onChange={(e) =>
                                            setForm((prev) => ({ ...prev, comments: e.target.value }))
                                        }
                                        className={`${"book-page-form-input-textarea"} ${form.comments === "" ? "" : "has-text"
                                            }`}
                                    ></textarea>
                                    <label htmlFor="comments">Comments</label>
                                </div>
                                {/* <Button type="button" onClick={saveComment}>
                  Save Comment
                </Button> */}
                            </div>
                        </div>

                        <div className="book-page-footer-container">
                            <div className="book-page-action-container" style={{ justifyContent: "end" }}>
                                {/* <a
                  href="javascript:void(0)"
                  class="book-page-queue-button"
                  onClick={handleGoToAbout}
                >
                  <span>
                    <svg
                width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.5 7L4.5 12L9.5 17"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        opacity="0.5"
                        d="M4.5 12L14.5 12C16.1667 12 19.5 13 19.5 17"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>{" "}
                  </span>
                  Queue Page
                </a> */}
                                <div className="book-page-buttons-container justify-space">
                                    <button
                                        type="button"
                                        className="reject-button"
                                        onClick={handleClear}
                                    >
                                        Clear
                                    </button>
                                    <button className="accept-button" disabled={isDisabled}>Submit</button>
                                    <Tooltip
                                        title={isDuplicateIsbn ? "Rejection is not permitted for duplicate ISBNs. Please proceed using the MRBQ workflow." : ""}
                                        color="#ffffff"
                                        overlayInnerStyle={{ color: "#004677", fontWeight: "600" }}
                                    >
                                        <span style={{ cursor: (isDisabled || isDuplicateIsbn) ? "not-allowed" : "pointer", display: "inline-block" }}>
                                            <button
                                                className="reject-button"
                                                type="button"
                                                disabled={isDisabled || isDuplicateIsbn}
                                                onClick={() => showRejectModal()}
                                                style={(isDisabled || isDuplicateIsbn) ? { pointerEvents: 'none' } : {}}
                                            >
                                                Reject
                                            </button>
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
};
export default MyForm;
